export const RESPONSE_CODES_ENUM = {
    SUCCESS: 0,
    CLIENT_NOT_FOUND: 1001,
    DUPLICATE_IDENTIFICATOR: 2486,
}